import { toast } from "sonner";

/**
 * Show an error toast with a "Reporter au support" action button.
 * The button opens the support dialog pre-filled with error context.
 *
 * Usage:
 *   const openSupport = useSupport().openSupport;
 *   errorToast(openSupport, "Impossible de charger", { module: "cagnottes", error_code: "E_LOAD", error_message: err.message });
 */
export function errorToast(openSupport, message, context = {}) {
  toast.error(message, {
    duration: 8000,
    action: openSupport
      ? {
          label: "Reporter au support",
          onClick: () =>
            openSupport({
              module: context.module || "autre",
              subject: context.subject || message.slice(0, 100),
              message: context.message || `Erreur rencontrée : ${message}`,
              target_id: context.target_id,
              target_url: context.target_url,
              error_message: context.error_message || message,
              error_code: context.error_code,
            }),
        }
      : undefined,
  });
}
